// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f71468ab","977":"649316c8"}[chunkId] + ".chunk.js";
};